<template>
  <div id="app">
  <div v-if="this.$router.history.current.name !='login'" class="wrapper" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
    <Sidebar />
    <div class="content">
        <Navbar :sidebar-collapsed="sidebarCollapsed" @toggle-sidebar="toggleDesktopSidebar" />
      <div class="content-body p-4 scroll-bar smooth" :class="{ 'pharmacy-redesign': !/^\/stock(?:\/(?:show|echange)\/[^/]+)?\/?$/.test($route.path) }">
            <router-view>
            </router-view>      
      </div>
     
    </div>
  </div>
    <div v-else>
        <router-view/>        
     </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Sidebar from '@/components/sidebar'
import Navbar from '@/components/navbar'

export default {
  data() { return { sidebarCollapsed: false }; },
  methods: { toggleDesktopSidebar() { this.sidebarCollapsed = !this.sidebarCollapsed; } },
  name: 'Home',
  components: {
    Sidebar,
    Navbar,
  }
}
</script>


<style>
@media (min-width: 1201px) {
  .wrapper.sidebar-collapsed > #sdbr { transform: translateX(-100%); visibility: hidden; }
  .wrapper.sidebar-collapsed > .content { padding-left: 0; }
  .wrapper.sidebar-collapsed > .content .navbar { left: 0; }
}
@media (prefers-reduced-motion: reduce) { #sdbr.sidebar { transition: none; } }
  .smooth {
      scroll-behavior: smooth;
  }
</style>
